'use client'

import BlurImage from '@/components/shared/blur-image'
import { placeholderBlurhash } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'
import React, { useEffect, useRef } from 'react'

const companies = [
  {
    name: 'Vakıflar Genel Müdürlüğü',
    logo: '/assets/images/companies/vakiflar-genel-mudurlugu.png',
    width: 237,
    height: 100,
    href: 'https://www.vgm.gov.tr/',
  },
  {
    name: 'Nilüfer Belediyesi',
    logo: '/assets/images/companies/nilufer-belediyesi.png',
    width: 100,
    height: 100,
    href: 'https://www.nilufer.bel.tr/',
  },
  {
    name: 'Tarım ve Orman Bakanlığı',
    logo: '/assets/images/companies/tarim-ve-orman-bakanligi.png',
    width: 412,
    height: 100,
    href: 'https://www.tarimorman.gov.tr/',
  },
  {
    name: 'Yıldırım Belediyesi',
    logo: '/assets/images/companies/yildirim-belediyesi.png',
    width: 186,
    height: 100,
    href: 'https://www.yildirim.bel.tr/',
  },

  {
    name: 'Mudanya Belediyesi',
    logo: '/assets/images/companies/mudanya-belediyesi.png',
    width: 100,
    height: 100,
    href: 'https://www.mudanya.bel.tr/',
  },

  {
    name: 'Bursa Valiliği',
    logo: '/assets/images/companies/bursa-valiligi.png',
    width: 100,
    height: 100,
    href: 'https://www.bursa.gov.tr/',
  },
  {
    name: 'Osmangazi Belediyesi',
    logo: '/assets/images/companies/osmangazi-belediyesi.png',
    width: 297,
    height: 83,
    href: 'https://www.osmangazi.bel.tr/',
  },
  {
    name: 'Kültür Bakanlığı',
    logo: '/assets/images/companies/kultur-bakanligi.png',
    width: 269,
    height: 100,
    href: 'https://www.ktb.gov.tr/',
  },
]

export function ReferencesList() {
  const scrollerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const scroller = scrollerRef.current
    if (!scroller || scroller.hasAttribute('data-animated')) return

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      addAnimation(scroller)
    }

    function addAnimation(scroller: HTMLDivElement) {
      scroller.setAttribute('data-animated', 'true')
      const scrollerInner = scroller.querySelector(
        '.scrolling-content'
      ) as HTMLDivElement
      if (scrollerInner) {
        const scrollerContent = Array.from(
          scrollerInner.children
        ) as HTMLElement[]
        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true) as HTMLElement
          duplicatedItem.setAttribute('aria-hidden', 'true')
          scrollerInner.appendChild(duplicatedItem)
        })
      }
    }
  }, [])

  return (
    <div className="grid grid-cols-1 place-items-center gap-9 py-24 md:grid-cols-2 lg:grid-cols-3 lg:gap-12">
      {companies.map((company, index) => (
        <div key={index} className="">
          <Link href={company.href} className="" target="_blank">
            <BlurImage
              src={company.logo}
              alt={company.name}
              width={company.width}
              height={company.height}
              loading="lazy"
              unoptimized
              placeholder="blur"
              blurDataURL={placeholderBlurhash}
              style={{ height: company.height, width: company.width }}
              className="grayscale transition-all duration-300 hover:grayscale-0 object-cover md:object-contain "
            />
            <span className="sr-only">{company.name}</span>
          </Link>
        </div>
      ))}
    </div>
  )
}
